import { Component, OnInit, Input, ViewChild, Output, EventEmitter, Inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { takeUntil } from 'rxjs/operators';

import * as CryptoJS from 'crypto-js';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformService } from '../services/platform.service';
import { NotificationService } from 'notification';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../services/auth.service';
import { ApiService } from 'profile';
import { LayoutService } from '../services/layout.service';
import { SharedService } from '../services/shared.service';
import { DhhpAlertComponent } from 'src/app/shared/dhhpalert/dhhpalert.component';
interface LangSupportByCountry {
  name: string;
  language: string;
  description: string;
}
interface ProfileApp {
  appId: string;
  appName: string;
  appRole: string;
  appCountry: string;
  status: string;
}
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild("contentRight") contentRight;
  @Input() RightNavData: any;
  componentDestroyed$: Subject<boolean> = new Subject();
  @Output() dataEvent = new EventEmitter();
  loginForm: FormGroup;
  // dialogRef: MatDialogRef<ConsentComponent, any>;
  submitted: boolean = false;
  adminEndpointAPI = environment.PLATFORM_AUTH;
  clientID = environment.ClientId;
  clientSecret = environment.ClientSecret;
  clientData = { clientId: this.clientID, clientSecret: this.clientSecret };
  APISingnature = "Account/LogIn";
  tokenKey: string;
  request: string;
  appTitle = "Health Platform";
  dataToPass: string;
  appParam: string = '';
  formData: any = {};
  dataSource: any;
  signUp = false;
  login = true;
  showCustomerLogin: boolean = false;
  initializeView: boolean = true;
  hartmannView: boolean = false;
  applicableLanguages = ['english', 'german']; 
  constructor(
    private sharedService: SharedService,
    private dataService: LayoutService,
    private apiService: ApiService,
    private formbuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    // private notifyService: NotificationService,
    private _http: PlatformService,
    private dialogBox: MatDialog,
    private dhhpAlert: DhhpAlertComponent,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
    this.translate.use("en");
    this.viewCustomerLogin();
    this.dataService.loginView$.pipe(takeUntil(this.componentDestroyed$)).subscribe((data) => {
      if (data.loginRedirection == "fromHartmannView") {
        this.showCustomerLogin = false;
        this.initializeView = false;
        this.hartmannView = true;
      }
      if (data.loginRedirection == "fromLoginView") {
        this.showCustomerLogin = true;
        this.initializeView = false;
        this.hartmannView = false;
      }
      if (data.loginRedirection == "fromMainView") {
        this.showCustomerLogin = false;
        this.initializeView = true;
        this.hartmannView = false;
      }
    });
    // if (this.authService.loggedIn()) {
    //   this.router.navigateByUrl('/dashboard');
    // }

    // this.tokenKey = environment.loginAccesstok;
    // this.apiService.apiUrl = environment.PLATFORM_AUTH;
    // this.notifyService.apiUrlSoc = environment.PLATFORM_AUTH;
    this.loginForm = this.formbuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    })
    this.appParam = decodeURIComponent(this.route.snapshot.queryParamMap.get('paramapp'));
    // this.dataService.signInPHusr$.pipe(takeUntil(this.componentDestroyed$)).subscribe(data => {
    //   if (data) {
    //     let formData = {
    //       code: data
    //     }
    //     this._http.signInPHUser(formData).
    //       pipe(takeUntil(this.componentDestroyed$)).subscribe({
    //         next: res => {
    //           this.storageData(res);
    //         },
    //         error: err => {
    //           // this.dhhpAlert.dhhpAlertError(err.error.message, '');
    //         }
    //       })

    //   }

    // })
    if (this.route.snapshot.queryParams.registration == "") {
      this.dataEvent.emit({ key: 'registration' })
    }
  }

  viewCustomerLogin() {
    this.showCustomerLogin = true;
    this.initializeView = false;
  }
  viewHartmannLogin() {
    this.hartmannView = true;
    this.initializeView = false;
    this.showCustomerLogin = false;
  }
  backLogin() {
    this.initializeView = true;
    this.showCustomerLogin = false;
  }
  backForm() {
    this.initializeView = true;
    this.hartmannView = false;
  }
  failureLogin(e) {
    // this.dhhpAlert.dhhpAlertError(e, '');
  }
  openForm(res) {

  }
  successLogin(data) {
    // localStorage.removeItem('Application');
    // this.authService.setToken(data.user_principal_name);
    // this.authService.setAccessToken(data.access_token);
    // this.authService.setDisplay(data.display_name);
    // this.authService.setRefreshToken(data.refresh_token);
    // if (this.appParam != 'null' && this.appParam != null) {
    //   this.document.location.href = this.appParam;
    // } else {
    //   this.router.navigateByUrl('/dashboard');
    // }
  }
  get f() {
    return this.loginForm.controls;
  }
  encryptUsingAES256(data: any) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenKey);
    let encrypted = CryptoJS.AES.encrypt(
      data, _key, {
      keySize: 128 / 8,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  submit() {
    const email = this.loginForm.value.username;
    const password = this.loginForm.value.password;
    if (email == null || email == undefined || email == "") {
      this.dhhpAlert.dhhpAlertError("Username cannot be empty", '');
      return;
    }
    if (password == null || password == undefined || password == "") {
      this.dhhpAlert.dhhpAlertError("Password cannot be empty", '');
      return;
    }
    this.authService.login(email, password).then(() => this.router.navigate(['/dashboard'])).catch(err => 
      {
        this.dhhpAlert.dhhpAlertError(err.message, '');
      });
  }

  // loginFun() {
  //   this.submitted = true;
  //   if (!this.loginForm.invalid) {
  //     let encrypyUname = this.encryptUsingAES256(this.loginForm.value.username);
  //     let encryPassword = this.encryptUsingAES256(this.loginForm.value.password);
  //     const formDataEncrypt = {
  //       username: encrypyUname,
  //       password: encryPassword,
  //     }
  //     this.formData = Object.assign({}, formDataEncrypt)
  //     this._http.login(this.formData).
  //       pipe(takeUntil(this.componentDestroyed$)).subscribe({
  //         next: data => {
  //           if (data) {
  //             var apps = data.userProfileObject.profileAppList as ProfileApp[];
  //             const validApp = apps?.find((app: ProfileApp) => app.appId === environment.appId &&
  //               app.status.toLowerCase() === 'approved' &&
  //               app.appRole === environment.appCustomerRoleId);
  //             if (!validApp) {
  //               this.dhhpAlert.dhhpAlertError(this.translate.instant("UnAuthorized"), '');
  //               return;
  //             }
  //             this.storageData(data);
  //           }
  //         },
  //         error: err => {
  //           // if(!!err)
  //           // this.dhhpAlert.dhhpAlertError(err.error.message, '');
  //         }
  //       })
  //   }
  // }
  // storageData(data) {
  //   if (data) {
  //     this.authService.setToken(data.user_principal_name);
  //     localStorage.removeItem('Lang');
  //     this.authService.setUserToken(data.userProfileObject.userId);
  //     this.authService.setSessionId(data.sessionId);
  //     this.authService.setExpiresIn(data.expires_in);
  //     this.authService.setExtExpiresIn(data.ext_expires_in);
  //     this.authService.setAccessToken(data.access_token);
  //     this.authService.setTimeSec(new Date());
  //     this.authService.setDisplay(data.display_name);
  //     this.authService.setCountryVal(data.userProfileObject.country);
  //     this.submitted = false;
  //     this.authService.setRefreshToken(data.refresh_token);
  //     this.authService.setUserProfileObject(data.userProfileObject);
  //     this.authService.setSelectedAPP(data.selectedApplications);
  //     this.authService.setPolicyData(data.appPolicyAgreements);
  //     this.authService.setUserPlanObject(data.userFacilitySubscriptions);
  //     const allLanguages: LangSupportByCountry[] = data.languageSupportByUserCountry;
  //     var relevantAppLanguages = allLanguages.filter((lang) => this.applicableLanguages.includes(lang.name.toLowerCase()));
  //     this.authService.setLanguageObject(relevantAppLanguages);
  //     localStorage.removeItem('defaultID');
  //     // this.dataService.getRoleValue = data.dhhpRole;
  //     this.dataService.getProfileData.next(data.userProfileObject);
  //     let loadLang = data.userProfileObject.country.toLowerCase();
  //     if (loadLang == 'au') {
  //       loadLang = 'en';
  //     }
  //     this.translate.use(loadLang);
  //     // if(data.userProfileObject.country != 'AU'){
  //     //   this.global.showLanguageManager.next(true);
  //     // }
  //     if (data.userProfileObject.associatedAccounts.length) {
  //       this.dataService.facilityAccount.next(data.userProfileObject.associatedAccounts[0]);
  //     }
  //     this.authService.setRole(data.userProfileObject.healthPlusRoleId);
  //     if (this.appParam != 'null' && this.appParam != null) {
  //       this.document.location.href = this.appParam;
  //     }
  //     if (data.userProfileObject.defaultAppUrl != "" && data.userProfileObject.defaultAppUrl != null) {
  //       this.document.location.href = data.userProfileObject.defaultAppUrl;
  //     } else {
  //       this.getFeaturesData(data.userProfileObject.healthPlusRoleId);
  //     }
  //   }
  // }
  getFeaturesData(roleId) {
    if (roleId != '')
      this._http.getRoleProfileById(roleId).subscribe({
        next: res => {
          if (res) {
            this.dataService.getProfileRoleData.next(res.features);
            this.dataService.userRoleData = res.features;
            this.router.navigateByUrl('/dashboard');
          } else {
            this.router.navigateByUrl('/dashboard');
          }
        },
        error: err => {
          // this.router.navigateByUrl('/dashboard');
          if (!!err && err.status == 500) {
            // this.dhhpAlert.dhhpAlertError(err.error.message, '')
          }
        }
      })

  }
  redirectForgot() {
    //if(this.forgotPasswordURL != '')
    this.dataEvent.emit({ key: 'forgotPassword' })
  }
  redirectToregister() {
    this.dataEvent.emit({ key: 'registration' });
    this.dataService.loginView.next({ loginRedirection: "fromLoginView" })
  }
  redirectToregisterMain() {
    this.dataEvent.emit({ key: 'registration' });
    this.dataService.loginView.next({ loginRedirection: "fromMainView" })
  }
  redirectToregisterHartMann() {
    this.dataEvent.emit({ key: 'registration' });
    this.dataService.loginView.next({ loginRedirection: "fromHartmannView" })
  }
  redirectToHartmannLogin() {
    let redirectURL = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${environment.ClientIDSignIn}&response_type=code&redirect_uri=${environment.Platform_URI_Redirect}/&response_mode=query&scope=openid%20offline_access%20user.read&state=12345&prompt=select_account`;
    this.document.location.href = redirectURL;
  }
  loginclick() {
    this.signUp = true;
    this.login = false;
  }
  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
} 
